import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment, useContext } from "react";
import { createPortal } from "react-dom";
import { GatewaysContext } from "./GatewayProvider";
/**
 * Renders children into {@linkcode GatewayDest} with the same `name`
 * @param props
 * @returns
 */
export function Gateway(props) {
    const gateways = useContext(GatewaysContext);
    const gatewayElement = gateways.get(props.into);
    return gatewayElement ? (createPortal(props.children, gatewayElement, props.into)) : (_jsx(Fragment, {}));
}
//# sourceMappingURL=Gateway.js.map